import {
    AnyValue,
    Property,
    isIntegerValue,
    isStringValue,
    isBooleanValue,
    isTextValue,
    isFloatValue,
    isDateValue,
    isDateTimeValue,
    isLinkValue,
    isRatingValue,
    isRelationOneValue,
} from '@varos/research-sdk';
import { assert, assertNever } from '@varos/util-typescript';
import { ReportingControllerBaseConfig } from '../../../../base';
import { RelationOneValueController } from './relationOneValueInterface';

import { useMemo } from 'react';
import { ValueIconProps, ValueViewProps } from '../../valueProps';
import { HiOutlineDocument, HiOutlineDocumentText } from 'react-icons/hi';
import { RelationOneValueAggregate } from './relationOneValueModel';

export function createRelationOneValueController(
    config: ReportingControllerBaseConfig
): RelationOneValueController {
    const {
        kernel: {
            infra: { formatter },
        },
    } = config;
    function getIcon(item: RelationOneValueAggregate): ValueIconProps {
        if (item.target?.icon) {
            return {
                kind: 'emoji',
                text: item.target.icon,
            };
        }

        return {
            kind: 'icon',
            Component: HiOutlineDocumentText,
        };
    }
    return {
        useProps(context, item, props): ValueViewProps {
            const value = useMemo((): ValueViewProps['value'] => {
                if (item.value === null) {
                    return null;
                }
                return {
                    kind: 'relation',
                    cardinality: item.property.config.cardinality,
                    label: item.target?.title ?? 'Deleted content',
                    icon: getIcon(item),
                    link: {
                        to: `?record=${item.value}`,
                    },
                };
            }, [item.property, item.value]);
            return {
                property: {
                    id: item.property.key,
                    label: item.property.display_name,
                },
                tooltip: {
                    label: item.property.display_name,
                },
                value,
            };
        },
    };
}
